import { useState } from "react";
import Icon from "../ui/Icon";
import MiniSpinner from "../ui/MiniSpinner";
import { THEMES, STAFF_SIGNATURES } from "../../config/constants";
import { btnP } from "../../utils/styles";

export default function ComposePanel({ onClose, theme, toEmail="", toName="", staffName="Bibek", replyTo=null, onSend=null, sendLoading=false, sendError="", msConnected=false }) {
  const t = THEMES[theme];
  const sig = STAFF_SIGNATURES[staffName] || STAFF_SIGNATURES.Bibek;
  const [to,   setTo]   = useState(toEmail);
  const [cc,   setCc]   = useState("");
  const [bcc,  setBcc]  = useState("");
  const [subj, setSubj] = useState(replyTo ? `Re: ${replyTo.subject}` : "");
  const [body, setBody] = useState("");
  const [showCc,  setShowCc]  = useState(false);
  const [showBcc, setShowBcc] = useState(false);
  const inp = (val, onChange, placeholder) => (
    <input value={val} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
      style={{background:"transparent",border:"none",outline:"none",color:t.text,fontSize:13,width:"100%",fontFamily:"'Outfit',sans-serif"}}/>
  );
  const row = (label, val, onChange, placeholder, extra) => (
    <div style={{display:"flex",alignItems:"center",gap:8,padding:"8px 14px",borderBottom:`1px solid ${t.border}`}}>
      <span style={{fontSize:11.5,color:t.textMuted,fontWeight:600,width:32,flexShrink:0}}>{label}</span>
      {inp(val, onChange, placeholder)}
      {extra}
    </div>
  );
  function handleSend() {
    if (!onSend || !to || !subj) return;
    const fullBody = body + "\n\n" + sig;
    onSend({ to, cc: cc||undefined, bcc: bcc||undefined, subject: subj, body: fullBody });
  }
  return (
    <div style={{position:"fixed",bottom:0,right:24,width:560,maxWidth:"95vw",background:t.surface,border:`1px solid ${t.border}`,borderRadius:"14px 14px 0 0",boxShadow:"0 -8px 40px #0006",zIndex:300,display:"flex",flexDirection:"column",maxHeight:"80vh"}}>
      {/* Header */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 16px",background:theme==="dark"?"#1a2540":"#1e3a5f",borderRadius:"14px 14px 0 0"}}>
        <div style={{fontSize:13.5,fontWeight:700,color:"#fff"}}>{replyTo?"Reply":"New Message"}</div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",color:"#fff99",fontSize:18,lineHeight:1,padding:"0 4px",opacity:0.8}}>×</button>
        </div>
      </div>
      {/* Fields */}
      <div style={{borderBottom:`1px solid ${t.border}`}}>
        {row("To", to, setTo, "Recipients",
          <div style={{display:"flex",gap:6,flexShrink:0}}>
            {!showCc  && <button onClick={()=>setShowCc(true)}  style={{fontSize:11,color:t.textMuted,background:"none",border:"none",cursor:"pointer",fontFamily:"'Outfit',sans-serif"}}>Cc</button>}
            {!showBcc && <button onClick={()=>setShowBcc(true)} style={{fontSize:11,color:t.textMuted,background:"none",border:"none",cursor:"pointer",fontFamily:"'Outfit',sans-serif"}}>Bcc</button>}
          </div>
        )}
        {showCc  && row("Cc",  cc,  setCc,  "Cc recipients")}
        {showBcc && row("Bcc", bcc, setBcc, "Bcc recipients")}
        {row("Subj", subj, setSubj, "Subject")}
      </div>
      {/* Body */}
      <div style={{flex:1,overflowY:"auto",padding:"12px 14px",minHeight:160}}>
        <textarea value={body} onChange={e=>setBody(e.target.value)} placeholder="Write your message..."
          style={{width:"100%",minHeight:120,background:"transparent",border:"none",outline:"none",color:t.text,fontSize:13,fontFamily:"'Outfit',sans-serif",resize:"none",boxSizing:"border-box"}}/>
        {/* Signature */}
        <div style={{borderTop:`1px solid ${t.border}`,marginTop:8,paddingTop:8}}>
          {sig.split("\n").map((line,i)=>(
            <div key={i} style={{fontSize:11.5,color:t.textMuted,lineHeight:1.7}}>{line}</div>
          ))}
        </div>
      </div>
      {/* Error */}
      {sendError && <div style={{padding:"6px 14px",fontSize:11.5,color:"#ef4444",background:"#ef444412"}}>{sendError}</div>}
      {/* Actions */}
      <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",borderTop:`1px solid ${t.border}`}}>
        {msConnected ? (
          <button onClick={handleSend} disabled={sendLoading||!to||!subj} style={{...btnP,display:"flex",alignItems:"center",gap:6,opacity:(sendLoading||!to||!subj)?0.5:1,cursor:(sendLoading||!to||!subj)?"not-allowed":"pointer"}}>
            {sendLoading?<><MiniSpinner size={13} color="#fff"/>Sending...</>:<><Icon name="mail" size={13} color="#fff"/>Send</>}
          </button>
        ) : (
          <button style={{...btnP,display:"flex",alignItems:"center",gap:6,opacity:0.5,cursor:"not-allowed"}} disabled>
            <Icon name="mail" size={13} color="#fff"/>Send
          </button>
        )}
      </div>
    </div>
  );
}

